"use client";
import NoImage from "@/public/no-image.jpg";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import CategoryCard from "@/app/category/[slug]/_components/category-card";
import {useRef} from "react";
import {MoveLeft, MoveRight} from "lucide-react";
import {Navigation} from 'swiper/modules';
import {ICategory} from "@/interface/components/category/category";
import type {Swiper as SwiperType} from 'swiper';

const SubCategoriesSlider = ({categories}: { categories: ICategory[] }) => {
    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);
    const swiperRef = useRef<SwiperType | null>(null);
    const categoriesLength = categories.length ?? 0
    return (
        <div className="relative">
            <div
                ref={prevRef}
                onClick={() => swiperRef.current?.slideNext()}
                className={`${categoriesLength <= 2 ? "!hidden" : '!flex'} ${categoriesLength <= 6 ? "md:!hidden flex" : 'md:!flex'} absolute left-0 top-[-40px] text-[#294580] hover:text-white  cursor-pointer w-6 h-6 border border-[#294580] flex items-center justify-center rounded p-0.5 hover:bg-[#294580] transition-all`}
            >
                <MoveLeft/>
            </div>

            <Swiper
                modules={[Navigation]}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                    if (prevRef.current && nextRef.current) {
                        swiper.params.navigation = {
                            prevEl: prevRef.current,
                            nextEl: nextRef.current,
                        };
                        swiper.navigation.init();
                        swiper.navigation.update();
                    }
                }}
                pagination={{clickable: true}}
                slidesPerView={2.5}
                spaceBetween={10}
                breakpoints={{
                    300:{
                        slidesPerView:2.5
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1260: {
                        slidesPerView: 6,
                    },
                }}
            >
                {categories?.map((category, index: number) => (
                    <SwiperSlide key={index}>
                        <CategoryCard
                            image={category?.media[0]?.url ?? NoImage}
                            title={category?.title}
                            slug={category?.slug}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            <div
                ref={nextRef}
                onClick={() => swiperRef.current?.slidePrev()}
                className={`${categoriesLength <= 2 ? "!hidden" : '!flex'} ${categoriesLength <= 6 ? "md:!hidden flex" : 'md:!flex'} absolute left-10 top-[-40px] cursor-pointer w-6 h-6 border border-[#294580] flex items-center justify-center rounded p-0.5 text-[#294580] hover:text-white hover:bg-[#294580] transition-all`}
            >
                <MoveRight/>
            </div>
        </div>
    );
};

export default SubCategoriesSlider;
